import { useState } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { CreditLimit } from './CreditLimit'
import { ServerLimit } from './ServerLimit'
import { StorageVolume } from './StorageVolume'

export const DashboardSettings = () => {
  const [activeTab, setActiveTab] = useState('credit')

  return (
    <div className="p-6" data-testid="organization-settings">
      <h1 className="text-3xl font-medium mb-2" data-testid="settings-title">
        User Limit Management
      </h1>
      <p
        className="text-muted-foreground dark:text-muted-foreground mb-4"
        data-testid="settings-description"
      >
        Configure resource limits for your organization's users
      </p>

      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="w-full"
        data-testid="settings-tabs"
      >
        <div className="relative flex justify-start">
          <TabsList className="mb-6" data-testid="settings-tabs-list">
            <TabsTrigger value="credit" data-testid="credit-limit-tab">
              Credit Limit
            </TabsTrigger>
            <TabsTrigger value="server" data-testid="server-limit-tab">
              Server Limit
            </TabsTrigger>
            <TabsTrigger value="storage" data-testid="storage-volume-tab">
              Storage Volume
            </TabsTrigger>
          </TabsList>
        </div>

        <div className="max-w-4xl">
          <TabsContent
            value="credit"
            className="mt-6"
            data-testid="credit-limit-content"
          >
            <CreditLimit />
          </TabsContent>
          <TabsContent
            value="server"
            className="mt-6"
            data-testid="server-limit-content"
          >
            <ServerLimit />
          </TabsContent>
          <TabsContent
            value="storage"
            className="mt-6"
            data-testid="storage-volume-content"
          >
            <StorageVolume />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  )
}
